import AccountManagePage from "./pages/AccountManagePage";
import CategoryInventoryPage from "./pages/CatogeryInventoryPage";
import CustomerPage from "./pages/CustomerPage";
import CustomerV2Page from "./pages/CustomerV2Page";
import CustomerPartnerPage from "./pages/CustomerPartnerPage";
import HomePage from "./pages/HomePage";
import InternetPackVariantPage from "./pages/InternetPackVariantPage";
import InternetPackagePage from "./pages/InternetPackagePage";
import LoginPage from "./pages/LoginPage";
import ProfilPage from "./pages/ProfilePage";
import ProjectPage from "./pages/ProjectPage";
import RegistrationsPartnerPage from "./pages/RegistrationsPartnerPage";
import ReportBastPage from "./pages/ReportBastPage";
import SettingPage from "./pages/SettingPage";
import SchedulerPage from "./pages/ShedulerPage";
import { default as UnderConstructionPage } from "./pages/UnderConstrcutionPage";
import UserRegistrationPage from "./pages/UserRegistrationPage";
import UserRegistrationV2Page from "./pages/UserRegistrationV2Page";
import WarehouseInventoryPage from "./pages/WarehouseInventoryPage";
import WarehousesPage from "./pages/WarehousesPage";
import ReportAddonPage from "./pages/addon/ReportAddonPage";
import StatsAddonPage from "./pages/addon/StatsAddonPage";
import AppsNotifTopicPage from "./pages/apps/AppsNotifTopicPage";
import HistoryPushNotifPage from "./pages/apps/HistoryPushNotifPage";
import UserMobilePage from "./pages/apps/UserMobilePage";
import CustomerExpiredPage from "./pages/customer/CustomerExpiredPage";
import CustomerRelationPage from "./pages/customer/CustomerRelationPage";
import ReactivateCustomerPage from "./pages/customer/ReactivateCustomerPage";
import ReportActivitiesPage from "./pages/customer/ReportActivitiesPage";
import ReportCustomerFtth from "./pages/customer/ReportCustomerFtth";
import ReportCustomerReactivationPage from "./pages/customer/ReportCustomerReactivationPage";
import ReportCustomerStatus from "./pages/customer/ReportCustomerStatus";
import ReportCustomerStatusFtth from "./pages/customer/ReportCustomerStatusFtth";
import ReportCustomerTrial from "./pages/customer/ReportCustomerTrial";
import ReportMigrationOltPage from "./pages/customer/ReportMigrationOltPage";
import ReportReminderCustomer from "./pages/customer/ReportReminderCustomer";
import RequestChangePackagePage from "./pages/customer/RequestChangePackagePage";
import { AutoTransferListPage } from "./pages/finance/AutoTransferListPage";
import BillingPage from "./pages/finance/BillingPage";
import BillingV2Page from "./pages/finance/BillingV2Page";
import BillingPartnerPage from "./pages/finance/BillingPartnerPage";
import DetailPointSales from "./pages/finance/DetailPointSales";
import PointSalesPage from "./pages/finance/PointSalesPage";
import ReportBillingSite from "./pages/finance/ReportBillingSite";
import ReportCommissions from "./pages/finance/ReportCommissions";
import ReportMonthlyPage from "./pages/finance/ReportMonthlyPage";
import ManageFramePoolPage from "./pages/infrastructure/ManageFramePoolPage";
import ManageOdpPage from "./pages/infrastructure/ManageOdpPage";
import ManageOltPage from "./pages/infrastructure/ManageOltPage";
import ManageOltProfilePage from "./pages/infrastructure/ManageOltProfilePage";
import OltByIdSlotPage from "./pages/infrastructure/OltByIdSlotPage";
import OltSlotPage from "./pages/infrastructure/OltSlotPage";
import ProjectUptimePage from "./pages/infrastructure/ProjectUptimePage";
import ProvisioningPartnerPage from "./pages/infrastructure/ProvisioningPartnerPage";
import ReportPerformancePage from "./pages/infrastructure/ReportPerformancePage";
import SplitterListPage from "./pages/infrastructure/SplitterListPage";
import AcceptOutgoingPage from "./pages/inventory/AcceptOutgoingPage";
import DataModemPage from "./pages/inventory/DataModemPage";
import HistoryModemPage from "./pages/inventory/HistoryModemPage";
import InventoryMasterPage from "./pages/inventory/InventoryMasterPage";
import ModemInventoryPage from "./pages/inventory/ModemInventoryPage";
import ReturnInventoryPage from "./pages/inventory/ReturnInventoryPage";
import LogSetupModemPage from "./pages/inventory/LogSetupModemPage";
import SetupModemPage from "./pages/inventory/SetupModemPage";
import WarehouseInventoryOutHistoryPage from "./pages/inventory/WarehouseInventoryOutHistoryPage";
import WarehouseInventoryOutPage from "./pages/inventory/WarehouseInventoryOutPage";
import WarehouseInventoryUploadPage from "./pages/inventory/WarehouseInventoryUploadPage";
import WarehouseManualAddInventoryPage from "./pages/inventory/WarehouseManualAddInventoryPage";
import WarehouseManualTransferPage from "./pages/inventory/WarehouseManualTransferPage";
import WarehouseTransferUploadPage from "./pages/inventory/WarehouseTransferUploadPage";
import DismantleKpiPage from "./pages/kpi/DismantleKpiPage";
import InstallationKpiPage from "./pages/kpi/InstallationKpiPage";
import ManagePartnersPage from "./pages/project/ManagePartnersPage";
import ManageVendorPage from "./pages/project/ManageVendorPage";
import ProjectVendorListPage from "./pages/project/ProjectVendorListPage";
import ProjectVendorReportPage from "./pages/project/ProjectVendorReportPage";
import PromoPackagePage from "./pages/promo/PromoPackagePage";
import ReportBastDismantlePage from "./pages/report/ReportBastDismantlePage";
import ReportBastRelocatePages from "./pages/report/ReportBastRelocatePage";
import BillingSalesPage from "./pages/sales/BillingSalesPage";
import RegistrationBySalesPage from "./pages/sales/RegistrationBySalesPage";
import SalesRegisteredPage from "./pages/sales/SalesRegisteredPage";
import DismantleSchedule from "./pages/schedules/DismantleSchedule";
import RelocateSchedule from "./pages/schedules/RelocateSchedule";
import AppAlertPage from "./pages/settings/AppAlertPage";
import AuditLogsPage from "./pages/settings/AuditLogsPage";
import BannerSettingPage from "./pages/settings/BannerSettingPage";
import BounceEmailPage from "./pages/settings/BounceEmailPage";
import CoverageSettingPage from "./pages/settings/CoverageSettingPage";
import RbacSettingPage from "./pages/settings/RbacSettingPage";
import WhatsappLogPage from "./pages/settings/WhatsappLogPage";
import HistoryTechnician from "./pages/technician/TechnicianHistoryPage";
import TechnicianPage from "./pages/technician/TechnicianPage";
import TicketingPage from "./pages/ticketing/TicketingPage";
import CampaignDetailPage from "./pages/campaign/CampaignDetailPage";
import CampaignPage from "./pages/campaign/CampaignPage";

export const router = [
  {
    "path": "/login",
    "name": "Login",
    "component": LoginPage
  },
  {
    "path": "/home",
    "name": "Home",
    "component": HomePage
  },
  {
    "path": "/users",
    "name": "User",
    "component": UserRegistrationPage
  },
  {
    "path": "/users-v2",
    "name": "User V2",
    "component": UserRegistrationV2Page
  },
  {
    "path": "/roles",
    "name": "Akun Role",
    "component": AccountManagePage
  },
  {
    "path": "/roles",
    "name": "Akun Role",
    "component": AccountManagePage
  },
    {
    "path": "/pendaftaran-partner",
    "name": "Pendafataran Partner",
    "component": RegistrationsPartnerPage
  },
  {
    "path": "/pelanggan-partner",
    "name": "Pelanggan Partner",
    "component": CustomerPartnerPage
  },
  {
    "path": "/billing-partner",
    "name": "Pelanggan Partner",
    "component": BillingPartnerPage
  },
  {
    "path": "/pelanggan",
    "name": "Manajemen Pelanggan",
    "component": CustomerPage
  },
  {
    "path": "/pelanggan-v2",
    "name": "Manajemen Pelanggan V2",
    "component": CustomerV2Page
  },
  {
    "path": "/pelanggan/request",
    "name": "Request Ganti Paket",
    "component": RequestChangePackagePage
  },
  {
    "path": "/pelanggan/jatuh-tempo",
    "name": "Pelanggan Belum Bayar",
    "component": CustomerExpiredPage
  },
  {
    "path": "/pelanggan/report-customer",
    "name": "Report Status Pelanggan",
    "component": ReportCustomerStatus
  },
  {
    "path": "/pelanggan/report-customer-due",
    "name": "Report Pelanggan Trial",
    "component": ReportCustomerTrial
  },
  {
    "path": "/pelanggan/report-reminder",
    "name": "Report Reminder Customer",
    "component": ReportReminderCustomer
  },
  {
    "path": "/pelanggan/report-ftth",
    "name": "Report Customer FTTH",
    "component": ReportCustomerFtth
  },
  {
    "path": "/pelanggan/report-status-ftth",
    "name": "Report Customer Status FTTH",
    "component": ReportCustomerStatusFtth
  },
  {
    "path": "/pelanggan/aktivitas",
    "name": "Report Aktivitas Pelanggan",
    "component": ReportActivitiesPage
  },
  {
    "path": "/pelanggan/reaktivasi",
    "name": "Aktivasi Pelanggan",
    "component": ReactivateCustomerPage
  },
    {
    "path": "/pelanggan/report-reaktivasi",
    "name": "Aktivasi Pelanggan",
    "component": ReportCustomerReactivationPage
  },
  {
    "path": "/pelanggan/:id/tickets",
    "name": "Tiket Pelanggan",
    "component": CustomerRelationPage
  },
  {
    "path": "/tickets",
    "name": "Ticketing",
    "component": TicketingPage
  },
  {
    "path": "/teknisi/riwayat",
    "name": "Riwayat Pemasangan",
    "component": HistoryTechnician
  },
  {
    "path": "/teknisi",
    "name": "Manajemen Teknisi",
    "component": TechnicianPage
  },
  {
    "path": "/jadwal/instalasi",
    "name": "Jadwal Instalasi",
    "component": SchedulerPage
  },
  {
    "path": "/jadwal/dismantle",
    "name": "Jadwal Dismantle",
    "component": DismantleSchedule
  },
  {
    "path": "/jadwal/relocate",
    "name": "Jadwal Relokasi",
    "component": RelocateSchedule
  },
  {
    "path": "/kpi/instalasi",
    "name": "KPI Instalasi",
    "component": InstallationKpiPage
  },
  {
    "path": "/kpi/dismantle",
    "name": "KPI Dismantle",
    "component": DismantleKpiPage
  },
  {
    "path": "/paket/tipe",
    "name": "Manajemen Paket",
    "component": InternetPackVariantPage
  },
  {
    "path": "/paket",
    "name": "Manajemen Paket",
    "component": InternetPackagePage
  },
  {
    "path": "/project",
    "name": "Manajemen Project",
    "component": ProjectPage
  },
  {
    "path": "/project/partners",
    "name": "Manajemen Mitra",
    "component": ManagePartnersPage
  },
  {
    "path": "/project/:id/work",
    "name": "Pekerjaan Proyek",
    "component": ProjectVendorListPage
  },
  {
    "path": "/project-vendor/:id/report",
    "name": "Progress Report Vendor",
    "component": ProjectVendorReportPage
  },
  {
    "path": "/project/vendor",
    "name": "Project Vendor",
    "component": ManageVendorPage
  },
  {
    "path": "/setup-modem/form",
    "name": "Form Setup Modem",
    "component": SetupModemPage
  },
  {
    "path": "/setup-modem/riwayat-modem",
    "name": "Form Setup Modem",
    "component": HistoryModemPage
  },
  {
    "path": "/setup-modem/data-modem",
    "name": "Form Setup Modem",
    "component": DataModemPage
  },
  {
    "path": "/setup-modem/log",
    "name": "Log Setup Modem",
    "component": LogSetupModemPage
  },
  {
    "path": "/setup-modem/olt",
    "name": "Manajemen OLT",
    "component": ManageOltPage
  },
    {
    "path": "/setup-modem/olt/:id/slot",
    "name": "Ketersediaan OLT",
    "component": OltByIdSlotPage
  },
  {
    "path": "/setup-modem/olt-profile",
    "name": "Manajemen Profil OLT",
    "component": ManageOltProfilePage
  },
  {
    "path": "/setup-modem/framed-pool",
    "name": "Manajemen Framed Pool",
    "component": ManageFramePoolPage
  },
  {
    "path": "/infrastructure/report/:id/project",
    "name": "Report Performance",
    "component": ProjectUptimePage
  },
  {
    "path": "/infrastructure/report",
    "name": "Report Performance",
    "component": ReportPerformancePage
  },
  {
    "path": "/infrastructure/olt-slot",
    "name": "Ketersediaan OLT",
    "component": OltSlotPage
  },
  {
    "path": "/infrastructure/odp-splitter-list",
    "name": "Ketersediaan OLT",
    "component": SplitterListPage
  },
  {
    "path": "/infrastructure/provisioning-partner",
    "name": "Ketersediaan OLT",
    "component": ProvisioningPartnerPage
  },
    {
    "path": "/infrastructure/odp",
    "name": "Ketersediaan OLT",
    "component": ManageOdpPage
  },
  {
    "path": "/form-bast/instalasi",
    "name": "Form BAST",
    "component": ReportBastPage
  },
  {
    "path": "/form-bast/dismantle",
    "name": "Form BAST",
    "component": ReportBastDismantlePage
  },
  {
    "path": "/form-bast/relocate",
    "name": "Form BAST Relocate",
    "component": ReportBastRelocatePages
  },
  {
    "path": "/settings/tnc",
    "name": "Halaman Settting",
    "component": UnderConstructionPage
  },
  {
    "path": "/settings/bounce-email",
    "name": "Halaman Settting",
    "component": BounceEmailPage
  },
  {
    "path": "/settings/whatsapp-log",
    "name": "Halaman Setting Whatsapp Log",
    "component": WhatsappLogPage
  },
  {
    "path": "/settings/coverage",
    "name": "Halaman Setting Coverage",
    "component": CoverageSettingPage
  },
  {
    "path": "/settings/audit-log",
    "name": "Halaman Setting Coverage",
    "component": AuditLogsPage
  },
  {
    "path": "/settings/rbac",
    "name": "Halaman Setting RBAC",
    "component": RbacSettingPage
  },
  {
    "path": "/settings",
    "name": "Halaman Settting",
    "component": SettingPage
  },
  {
    "path": "/apps/user-mobile",
    "name": "Halaman Akun Pengguna Aplikasi",
    "component": UserMobilePage
  },
  {
    "path": "/apps/app-alert",
    "name": "Halaman Pengumuman Aplikasi",
    "component": AppAlertPage
  },
  {
    "path": "/apps/topics",
    "name": "Halaman Manajemen Topik Apps",
    "component": AppsNotifTopicPage
  },
  {
    "path": "/apps/history-push-topics",
    "name": "Halaman Riwayat Topik Apps",
    "component": HistoryPushNotifPage
  },
  {
    "path": "/apps/banner",
    "name": "Halaman Banner Aplikasi",
    "component": BannerSettingPage
  },
  {
    "path": "/profile",
    "name": "Profil",
    "component": ProfilPage
  },
  {
    "path": "/warehouses/:id/inventory",
    "name": "Manajemen Inventory dalam Gudang",
    "component": WarehouseInventoryPage
  },
  {
    "path": "/warehouses/:id/manual-inventory",
    "name": "Tambah Tranfer dari Gudang",
    "component": WarehouseManualAddInventoryPage
  },
  {
    "path": "/warehouses/:id/manual-transfer",
    "name": "Manual Tranfer dari Gudang",
    "component": WarehouseManualTransferPage
  },
  {
    "path": "/warehouses/:id/transfer-upload",
    "name": "Upload Tranfer dari Gudang",
    "component": WarehouseTransferUploadPage
  },
  {
    "path": "/warehouses/:id/inventory-upload",
    "name": "Upload Inventory Gudang",
    "component": WarehouseInventoryUploadPage
  },
  {
    "path": "/warehouses/:id/inventory-out",
    "name": "Pengeluaran Inventory Gudang",
    "component": WarehouseInventoryOutPage
  },
  {
    "path": "/warehouses/:id/inventory-out-history",
    "name": "Riwayat Pengeluaran Inventory Gudang",
    "component": WarehouseInventoryOutHistoryPage
  },
  {
    "path": "/warehouses/:warehouseId/inventory/:id/modems",
    "name": "Manajemen Inventory Modem",
    "component": ModemInventoryPage,
  },
  {
    "path": "/warehouses/categories",
    "name": "Manajemen Kategori",
    "component": CategoryInventoryPage
  },
  {
    "path": "/warehouses/return",
    "name": "Manajemen Barang Masuk",
    "component": ReturnInventoryPage
  },
  {
    "path": "/warehouses/inventory/:id/accept",
    "name": "Terima Barang Keluar",
    "component": AcceptOutgoingPage
  },
  {
    "path": "/warehouses/inventory",
    "name": "Terima Barang Keluar",
    "component": InventoryMasterPage
  },
  {
    "path": "/warehouses",
    "name": "Manajemen Gudang",
    "component": WarehousesPage
  },
  {
    "path": "/promo/package",
    "name": "Manajemen Promo",
    "component": PromoPackagePage
  },
  {
    "path": "/finance/billing",
    "name": "Billing",
    "component": BillingPage
  },
  {
    "path": "/finance/billing-v2",
    "name": "Billing V2",
    "component": BillingV2Page
  },
  {
    "path": "/finance/auto-transfer-list",
    "name": "Auto Transfer List",
    "component": AutoTransferListPage
  },
  {
    "path": "/finance/report-payment",
    "name": "Report Payment per Site",
    "component": ReportBillingSite
  },
  {
    "path": "/finance/report-commissions",
    "name": "Report Komisi ke PulsaPro",
    "component": ReportCommissions
  },
  {
    "path": "/finance/report-monthly",
    "name": "Report Keuangan Bulanan",
    "component": ReportMonthlyPage
  },
  {
    "path": "/point-sales/:id/detail",
    "name": "Detail Point Sales",
    "component": DetailPointSales
  },
  {
    "path": "/point-sales",
    "name": "Poin Sales & Affiliator",
    "component": PointSalesPage
  },
  {
    "path": "/sales/register",
    "name": "Halaman Registrasi",
    "component": RegistrationBySalesPage
  },
  {
    "path": "/sales/data",
    "name": "Halaman Registrasi",
    "component": SalesRegisteredPage
  },
  {
    "path": "/sales/billing",
    "name": "Tagihan",
    "component": BillingSalesPage
  },
  {
    "path": "/pelanggan/addons",
    "name": "Addons",
    "component": ReportAddonPage
  },
  {
    "path": "/pelanggan/addons-stat",
    "name": "Statistik Addon Pelanggan",
    "component": StatsAddonPage
  },
  {
    "path": "/pelanggan/migrasi-olt",
    "name": "Laporan Migrasi OLT",
    "component": ReportMigrationOltPage
  },
    {
    "path": "/campaign",
    "name": "Campaign",
    "component": CampaignPage
  },
  {
    "path": "/campaign/:id",
    "name": "Campaign Detail",
    "component": CampaignDetailPage
  },
];
